 /**
  * Example usage below
  * <s-countdown data-targetdate="{{ targetDate }} {{ targetTime }}">
    <p js-stage-default>
    </p>
    <p js-stage-complete>
    </p>
    <p js-stage-default>
        <span class="" js-countdown-days>00</span> DAYS :
        <span class="" js-countdown-hours>00</span> HR :
        <span class="" js-countdown-minutes>00</span> MIN :
        <span class="" js-countdown-seconds>00</span> SEC
    </p>
    <p js-stage-complete>
    </p>
  *</s-countdown> 
**/

dayjs.extend(dayjs_plugin_utc);
dayjs.extend(dayjs_plugin_timezone);
dayjs.tz.setDefault("America/Los_Angeles");


class Countdown extends HTMLElement {
    constructor() {
      super();
  
      this._selectors = {
        countdown: {
            days: '[js-countdown-days]',
            hours: '[js-countdown-hours]',
            minutes: '[js-countdown-minutes]',
            seconds: '[js-countdown-seconds]'
        },
        jsonData: '[js-countdown-data]',
        stages: {
            default: '[js-stage-default]',
            complete: '[js-stage-complete]'
        }
      }
      
      this.stages = {
        default: this.querySelectorAll(this._selectors.stages.default),
        complete: this.querySelectorAll(this._selectors.stages.complete)
      }

      this.countdown = {
        days: this.querySelector(this._selectors.countdown.days),
        hours: this.querySelector(this._selectors.countdown.hours),
        minutes: this.querySelector(this._selectors.countdown.minutes),
        seconds: this.querySelector(this._selectors.countdown.seconds)
      }

    }
  
    connectedCallback() {
        const targetDate = this.getAttribute('data-targetdate')
        this._initCountdown(targetDate)
        this._adjustItemsWidth();
        this._displayCountdown()
    }

    _setStage(stage){
        if(stage == 'complete'){
            this.stages.complete.forEach((item) => item.classList.remove('hidden'))
            this.stages.default.forEach((item) => item.classList.add('hidden'))
        } else if(stage == 'default') {
            this.stages.default.forEach((item) => item.classList.remove('hidden'))
            this.stages.complete.forEach((item) => item.classList.add('hidden'))
        }
    }

    _displayCountdown(){
        this.classList.remove('opacity-0')
        this.classList.add('opacity-100')
    }

    _initCountdown(targetDate){
        const deadlinePT = dayjs.tz(new Date(targetDate), 'America/Los_Angeles')
        const deadline = new Date(deadlinePT).getTime()
    
        const formatTime = (time) => {
            return String(time).padStart(2, '0')
        }
    
        const interval = setInterval(() => {
            const nowPT = new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
            let nowPTDays = new dayjs(nowPT)
            let now = new Date(nowPTDays).getTime()
            let t = deadline - now
        
            if (t <= 0) {
                if (this.countdown.days) this.countdown.days.innerHTML = formatTime(0)
                if (this.countdown.hours) this.countdown.hours.innerHTML = formatTime(0)
                if (this.countdown.minutes) this.countdown.minutes.innerHTML = formatTime(0)
                if (this.countdown.seconds) this.countdown.seconds.innerHTML = formatTime(0)
                clearInterval(interval)
                if(this.stages.complete) this._setStage('complete')
                return
            }
    
            if (this.countdown.days) this.countdown.days.innerHTML = formatTime(Math.floor(t / (1000 * 60 * 60 * 24)))
            if (this.countdown.hours) this.countdown.hours.innerHTML = formatTime(Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
            if (this.countdown.minutes) this.countdown.minutes.innerHTML = formatTime(Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)))
            if (this.countdown.seconds) this.countdown.seconds.innerHTML = formatTime(Math.floor((t % (1000 * 60)) / 1000))
            this._setStage('default')
            
        }, 1000)

    }

    _adjustItemsWidth() {
        let maxWidth = 0;

        this.querySelectorAll('[js-countdown-item]').forEach(item => {
            if (item) {
                const width = item.offsetWidth;
                if (width > maxWidth) {
                    maxWidth = width;
                }
            }
        });

        this.querySelectorAll('[js-countdown-item]').forEach(item => {
            if (item) {
                item.style.width = `${maxWidth}px`;
            }
        });
    }
}

customElements.define('s-countdown', Countdown);